import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";

export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-10 py-14" data-testid="privacy-page">
      <Link to="/" className="inline-flex items-center gap-2 text-sm text-ink-muted hover:text-brand">
        <ArrowLeft className="w-4 h-4" /> Torna alla home
      </Link>
      <div className="mt-6 flex items-center gap-3">
        <div className="w-10 h-10 rounded bg-brand/10 text-brand flex items-center justify-center">
          <ShieldCheck className="w-5 h-5" />
        </div>
        <div>
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-brand/10 text-brand rounded-full text-[11px] font-display uppercase tracking-[0.2em]">
            Documento legale
          </div>
          <h1 className="mt-2 font-display text-3xl sm:text-4xl text-ink">Informativa Privacy</h1>
          <p className="mt-1 text-xs text-ink-muted">Ultimo aggiornamento: {new Date().toLocaleDateString("it-IT", { month: "long", year: "numeric" })}</p>
        </div>
      </div>

      <div className="mt-8 prose prose-sm sm:prose-base max-w-none text-ink">
        <p>
          La presente informativa descrive le modalità di trattamento dei dati personali degli utenti che consultano
          il sito <strong>iperammortamentovalore.com</strong> (di seguito, "Sito") ai sensi dell'articolo 13 del
          Regolamento UE 2016/679 ("GDPR").
        </p>

        <h2>1. Titolare del trattamento</h2>
        <p>
          Il Titolare del trattamento dei dati è <strong>Studio Ingegneria Valore</strong>,
          con sede in Via Ca' Brusà 16, 37030 Lavagno (VR), Italia.<br />
          Email di contatto: <a href="mailto:info@iperammortamentovalore.com" className="text-brand">info@iperammortamentovalore.com</a>
        </p>

        <h2>2. Finalità del trattamento</h2>
        <p>I dati raccolti attraverso il Sito sono trattati esclusivamente per le seguenti finalità:</p>
        <ul>
          <li><strong>Simulazione fiscale</strong>: calcolo dei benefici legati all'iperammortamento e alla Nuova Sabatini.</li>
          <li><strong>Registrazione utente</strong>: creazione dell'account per salvare le simulazioni e caricare la documentazione.</li>
          <li><strong>Richiesta di contatto</strong>: gestione delle richieste inviate tramite form.</li>
          <li><strong>Analisi statistiche interne</strong>: valutazione anonima dell'utilizzo del Sito per migliorarne il funzionamento.</li>
        </ul>

        <h2>3. Tipologie di dati raccolti</h2>
        <ul>
          <li>Dati di navigazione anonimi (indirizzo IP, browser, orario di accesso).</li>
          <li>Dati anagrafici forniti dall'utente in sede di registrazione (ragione sociale, P.IVA, città, telefono, email, nome del referente).</li>
          <li>Dati economici inseriti nel calcolatore (esclusivamente in forma di stima).</li>
          <li>Documentazione caricata volontariamente dall'utente per la propria pratica.</li>
        </ul>

        <h2>4. Base giuridica</h2>
        <p>
          Il trattamento è fondato sul consenso liberamente prestato dall'utente (art. 6, par. 1, lett. a GDPR)
          e sull'esecuzione di misure precontrattuali richieste dall'interessato (art. 6, par. 1, lett. b GDPR).
        </p>

        <h2>5. Modalità di trattamento e sicurezza</h2>
        <p>
          I dati sono trattati con strumenti elettronici, protetti da misure di sicurezza tecniche e organizzative
          adeguate a prevenire l'accesso non autorizzato, la perdita, la distruzione o l'alterazione.
          I dati <strong>non sono condivisi con terzi</strong> se non nei casi previsti dalla legge o dietro
          esplicito consenso dell'utente.
        </p>

        <h2>6. Conservazione dei dati</h2>
        <p>
          I dati vengono conservati per il tempo strettamente necessario alle finalità per cui sono stati raccolti
          e, comunque, non oltre 24 mesi dall'ultimo accesso dell'utente, salvo obblighi di legge.
        </p>

        <h2>7. Diritti dell'interessato</h2>
        <p>
          In qualsiasi momento l'utente può esercitare i diritti previsti dagli articoli da 15 a 22 del GDPR:
          accesso, rettifica, cancellazione, limitazione, portabilità e opposizione al trattamento.
          Per esercitare tali diritti è sufficiente scrivere a{" "}
          <a href="mailto:info@iperammortamentovalore.com" className="text-brand">info@iperammortamentovalore.com</a>.
        </p>

        <h2>8. Cookie</h2>
        <p>
          Il Sito utilizza esclusivamente cookie tecnici e di sessione strettamente necessari al funzionamento
          delle funzionalità (autenticazione, salvataggio simulazioni). Non vengono utilizzati cookie di profilazione
          di terze parti. Al primo accesso viene mostrato un banner che consente di accettare o rifiutare i cookie non essenziali.
        </p>

        <h2>9. Modifiche</h2>
        <p>
          La presente informativa potrà essere aggiornata nel tempo. Si invita l'utente a consultarla periodicamente.
        </p>
      </div>
    </div>
  );
}
